/**
 * In Contentful, a content editor may select incompatible components for the right hand side
 * of a main menu dropdown.
 * E.g. they may try to insert a ResourceNoImage into the SubmenuLayoutOne,
 * which will break the design. This is prevented by looking up allowed components
 * for each layout from menu.js.
 * TODO: consider removing menu.js and hardcoding the allowed components in each layout.
 * NOTE: only the key in the mainMenu object is significant. The value is superfluous.
 */
export const mainMenu = {
    // "Page - Why Qlik": {
    "Layout - Why Qlik": {
        "Component - Card with No Border": "Component - Card with No Border",
        "Component - Card Icon": "CardIcon",
    },
    "Layout - Technology Partners": {
        "Component - Card with Border": "CardWithBorder",
        "Component - Sub Menu with Icon": "SubMenuWithIcon",
    },
    // },
    // "Page - Products": {
    "Layout - Data Integration": {
        "Component - Card with No Border": "CardWithNoBorder",
        "Component - Sub Menu Grid": "SubMenuGrid",
        "Component - Link with Description 1 Col": "LinkWithDescriptionOneCol",
        "Component - Resource Card Small": "ResourceCardSmall",
    },
    "Layout - All Products": {
        "Component - Link with Description 2 Col": "LinkWithDescriptionTwoCol",
        "Component - Link with Description 1 Col": "LinkWithDescriptionOneCol",
    },
    // },
    // "Page - Solutions": {
    "Layout - By Industry": {
        "Component - Link with Icon": "LinkWithIcon",
    },
    // "Layout - Why Qlik": {
    //     "Component - Card with No Border": "CardWithNoBorder",
    //     "Component - Card Icon": "CardIcon",
    // },
    // },
    // "Page - Pricing": {
    "Layout - Pricing": "Component_Link_With_Icon_Description",
    // },
    // "Page - Learn": {
    "Layout - By Role": {
        "Component - Resource Card": "ResourceCard",
        "Component - Resource No Image": "ResourceNoImage",
        "Component - Cta": "Component_Cta",
    },
    "Layout - Topics and Trends": {
        "Component - Link with Description 2 Col": "LinkWithDescriptionTwoCol",
        "Component - Cta": "Component_Cta",
    },
    "Layout - Glossary": {
        "Component - Resource Card": "ResourceCard",
        "Component - Link with Description 1 Col": "LinkWithDescriptionOneCol",
        "Component - Cta": "Component_Cta",
    },
    "Layout - Community": {
        "Component - Link with Description 2 Col": "LinkWithDescriptionTwoCol",
    },
    // },
};
